import { gql } from "apollo-boost";

export const GET_ALL_AD_UNITS = gql`
  query adUnits {
    adUnits {
      id
      publisherId
      sizes {
        size
      }
      slot
      domain
      tag
    }
  }
`;

export const ADD_AD_UNIT = gql`
  mutation createAdUnit($input: AdUnitInput!) {
    createAdUnit(input: $input) {
      id
      publisherId
      sizes {
        size
      }
      slot
      tag
    }
  }
`;

export const DELETE_AD_UNIT = gql`
  mutation deleteAdUnit($slot: String!) {
    deleteAdUnit(slot: $slot) {
      id
      publisherId
      sizes {
        size
      }
      slot
      tag
    }
  }
`;

export const EDIT_AD_UNIT = gql`
  mutation updateAdUnit($id: String!, $input: AdUnitInput!) {
    updateAdUnit(id: $id, input: $input) {
      publisherId
      sizes {
        size
      }
      slot
      tag
    }
  }
`;

export const FIND_ADUNITS_DOMAINS = gql`
  query {
    findAdUnitsDomains {
      domain
      publisherId
    }
  }
`;

export const FIND_ADUNITS_BY_PLUBLISHERID = gql`
  query findAdUnitsByPublisherId($publisherId: String!) {
    findAdUnitsByPublisherId(publisherId: $publisherId) {
      id
      publisherId
      tag
      slot
      sizes {
        size
      }
    }
  }
`;

export const FIND_ADUNITS_BY_PLUBLISHERID_DYNAMIC = publisherId => {
  return gql`
    query findAdUnitsByPublisherId($publisherId: String!) {
      findAdUnitsByPublisherId(publisherId: "${publisherId}") {
        id
        publisherId
        tag
        slot
        sizes {
          size
        }
      }
    }
  `;
};
